import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _ElectronicPayroll } from '../../../../core/services/dataBean/EntityCatalogVdos';
import useModal, { MODAL_XL } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';
import usePaginator from '../../../theme/Component/usePaginator';
import { ValueTypeConstants } from './ValueTypeConstants';
import { BasicButton } from '../../../theme/Component/BasicButton';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const ElectronicPayrollEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_ElectronicPayroll)
    const [id, setID] = useState(null);
    const paginador = usePaginator();
    const [consttype, setconsttype] = useState<number>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const modal = useModal("Conceptos de Nómina Electrónica", MODAL_XL);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDElectronicPayroll == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getElectronicPayrollCatalog(consttype, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDElectronicPayroll', visible: true },
        { title: 'Tipo de Concepto', property: 'ValueTypeName', visible: true },
        { title: 'Propiedad', property: 'PropertyName', visible: true },
        { title: 'Ruta Documento Valor', property: 'QuantityProperty', visible: true },
        { title: 'Ruta Documento Cantidad', property: 'DefaultValue', visible: true },
        // { title: 'Tipo', property: 'ValueTypeName', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Conceptos de Nómina Electrónica"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <ValueTypeConstants idSelector={consttype} onChange={(e) => { setconsttype(e) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Búsqueda por Texto</label>
                        <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                            Buscar
                        </BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDElectronicPayroll); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}